export default "__VITE_ASSET__df065567__"